const Colors = {
    //Solid Colors
    white: '#FFF',
    black: '#000',
    red2: '#EB5757',
    //Custom Colors
    purple: '#3f51b5',
    cotemar: '#2A4A84',
    primary: '#2D9CDB',
    secondary: '#FF6A26',
    foggy: '#768591',
    dark: '#364350',
    darker: '#252F38',
    gray: '#595959',
    green: '#3AB54A',
    warn: '#FF5000',
    sub:'#FF7333',
    red: '#f50057',
    version: '#ffd469'
};

export default Colors;